import React, { Component } from 'react';
import { ClipLoader } from 'react-spinners';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { getAuth, signInWithEmailLink } from 'firebase/auth';
import { requestPasswordReset, verifyPasswordResetCode } from '../actions/authentication';
import '../App.css';

class ForgotPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      code: '',
      phase: 'email',
      loading: false,
      error: null,
    };
  }

  handleRequestCode = async (event) => {
    event.preventDefault();
    if (!this.state.email) {
      this.setState({ error: 'Please enter your email address.' });
      return;
    }
    this.setState({ loading: true, error: null });
    try {
      await requestPasswordReset(this.state.email);
      this.setState({ phase: 'code', loading: false });
    } catch {
      this.setState({ error: 'Something went wrong. Please try again.', loading: false });
    }
  }

  handleVerifyCode = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });

    let oobCode;
    try {
      oobCode = await verifyPasswordResetCode(this.state.email, this.state.code);
    } catch {
      this.setState({ error: 'Invalid or expired code. Please try again.', loading: false });
      return;
    }

    try {
      const auth = getAuth();
      const { apiKey, authDomain } = auth.app.options;
      const emailLink = `https://${authDomain}/__/auth/action?mode=signIn&oobCode=${oobCode}&apiKey=${apiKey}`;
      await signInWithEmailLink(auth, this.state.email, emailLink);
    } catch {
      this.setState({ error: 'Sign in failed. Please try again.', loading: false });
    }
  }

  renderError = () => {
    if (!this.state.error) return null;
    return <div style={{ paddingBottom: 20, color: 'red' }}>{this.state.error}</div>;
  }

  renderContent = () => {
    if (this.state.loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ClipLoader loading={true} />
        </div>
      );
    }

    if (this.state.phase === 'code') {
      return (
        <Form onSubmit={this.handleVerifyCode}>
          <p style={{ marginBottom: 20 }}>A code has been sent to <strong>{this.state.email}</strong>. Enter it below.</p>
          <FormGroup>
            <Label for="resetCode">Reset Code</Label>
            <Input
              type="text"
              name="code"
              id="resetCode"
              maxLength={6}
              placeholder="XXXXXX"
              onChange={(event) => this.setState({ code: event.target.value, error: null })}
            />
          </FormGroup>
          {this.renderError()}
          <Button color="success" type="submit" disabled={this.state.code.length !== 6}>Submit</Button>
        </Form>
      );
    }

    return (
      <Form onSubmit={this.handleRequestCode}>
        <FormGroup>
          <Label for="resetEmail">Email</Label>
          <Input
            type="email"
            name="email"
            id="resetEmail"
            placeholder=""
            onChange={(event) => this.setState({ email: event.target.value, error: null })}
          />
        </FormGroup>
        {this.renderError()}
        <Button color="success" type="submit">Send Code</Button>
      </Form>
    );
  }

  render() {
    return (
      <div className="LoginContainer">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <button
            type="button"
            onClick={this.props.onBack}
            style={{ background: 'none', border: 'none', padding: 0, color: '#0d6efd', cursor: 'pointer', fontSize: '1rem', alignSelf: 'flex-start' }}
          >
            &#8249; Back to Sign In
          </button>
          <div style={{ marginTop: 12 }} className="LoginForm">
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordContainer;
